import { createFileRoute } from '@tanstack/react-router'

// The leaf that makes the pathless `_request` layout match on bare `/oauth/authorize`; it renders nothing.
export const Route = createFileRoute('/_public/oauth/authorize/_request/')({})
